const FreeWriteBuilderModalEnum = {
  DOCUMENT_READY_FREEWRITE_MODAL: 'DOCUMENT_READY_FREEWRITE_MODAL',
  ERASER_FREEWRITE_MODAL: 'ERASER_FREEWRITE_MODAL',
  FREEWRITE_MODAL_CLOSE: 'FREEWRITE_MODAL_CLOSE',
  FREEWRITE_MODAL_OPEN: 'FREEWRITE_MODAL_OPEN',
  HIGHLIGHTER_FREEWRITE_MODAL: 'HIGHLIGHTER_FREEWRITE_MODAL',
  REDACT_FREEWRITE_MODAL: 'REDACT_FREEWRITE_MODAL',
};

export default FreeWriteBuilderModalEnum;



// WEBPACK FOOTER //
// ./src-react/FreeWriteBuilderModals/FreeWriteBuilderModalConstants.jsx